var exports = {
  "i": "x112a1f60--1bd102--main",
};

module.exports = exports;
